/* eslint-disable boundaries/no-ignored */
import AsteriskIcon from './asterisk.svg?react'
import CheckGreenIcon from './check-green.svg?react'
import CheckGreen3Icon from './check-green-3.svg?react'
import VariableCheckIcon from './variable-check-green.svg?react'
import TranslateIcon from './translate.svg?react'
import DeleteIcon from './delete.svg?react'
import DeleteWithCrossIcon from './deleteWithCross.svg?react'
import DoneIcon from './done.svg?react'
import PinIcon from './pin.svg?react'
import WarningIcon from './warning.svg?react'
import UnpinIcon from './unpin.svg?react'
import MicIcon from './mic.svg?react'
import ExitIcon from './exit.svg?react'
import CameraOnIcon from './camera-on.svg?react'
import CameraOffIcon from './camera-off.svg?react'
import ArrowLeftIcon from './arrow-left.svg?react'
import ArrowRightIcon from './arrow-right.svg?react'
import UserIcon from './user.svg?react'
import HistoryIcon from './history.svg?react'
import KeyboardIcon from './keyboard.svg?react'
import HelpIcon from './help.svg?react'
import SlowIcon from './slow.svg?react'
import SubtitleIcon from './subtitle.svg?react'
import SubtitleOffIcon from './subtitle-off.svg?react'
import PlayIcon from './play.svg?react'
import PlayMessageIcon from './play-message.svg?react'
import PauseMessageIcon from './pause-message.svg?react'
import CheckIcon from './check.svg?react'
import LockIcon from './lock.svg?react'
import DictionaryIcon from './dictionary.svg?react'
import UnfoldIcon from './unfold.svg?react'
import ThumbupIcon from './thumbup.svg?react'
import CloseIcon from './close.svg?react'
import LeftIcon from './left.svg?react'
import ProfileIcon from './profile.svg?react'
import LearningIcon from './learning.svg?react'
import GrammarIcon from './grammar.svg?react'
import WordsIcon from './words.svg?react'
import SendIcon from './send.svg?react'
import ArrowUpIcon from './arrow-up.svg?react'
import ArrowDownIcon from './arrow-down.svg?react'
import MenuIcon from './menu.svg?react'
import VoiceIcon from './voice.svg?react'
import SupportIcon from './support.svg?react'
import BulbIcon from './bulb.svg?react'
import ZoomIcon from './zoom.svg?react'
import KeyIcon from './key.svg?react'
import UnmuteIcon from './unmute.svg?react'
import MuteIcon from './mute.svg?react'
import TrendUpIcon from './trendUp.svg?react'
import Profile2Icon from './profile2.svg?react'
import EyeCloseIcon from './eye-close.svg?react'
import EyeOpenIcon from './eye-open.svg?react'
import MessageIcon from './message.svg?react'
import SpeakerIcon from './speaker.svg?react'
import TickSvg from './tick.svg?react'
import PlusSvg from './plus.svg?react'
import ClickhandSvg from './clickHand.svg?react'
import NavStarSvg from './navStar.svg?react'
import HomeSvg from './home.svg?react'
import BellSvg from './bell.svg?react'
import HeadphoneSvg from './headphone.svg?react'
import BookSvg from './book.svg?react'
import StarSvg from './star.svg?react'
import LockOpenSvg from './lock-open.svg?react'
import LockClosedSvg from './lock-closed.svg?react'
import CheckGreen2Svg from './check-green2.svg?react'
import RingSvg from './ring.svg?react'
import GoogleSvg from './google.svg?react'
import AppleSvg from './apple.svg?react'
import React from 'react'

const icons = {
  message: MessageIcon,
  translate: TranslateIcon,
  unmute: UnmuteIcon,
  done: DoneIcon,
  mute: MuteIcon,
  pin: PinIcon,
  delete: DeleteIcon,
  deleteWithCross: DeleteWithCrossIcon,
  warning: WarningIcon,
  unpin: UnpinIcon,
  exit: ExitIcon,
  mic: MicIcon,
  cameraOn: CameraOnIcon,
  cameraOff: CameraOffIcon,
  arrowLeft: ArrowLeftIcon,
  arrowRight: ArrowRightIcon,
  user: UserIcon,
  history: HistoryIcon,
  keyboard: KeyboardIcon,
  help: HelpIcon,
  slow: SlowIcon,
  subtitle: SubtitleIcon,
  subtitleOff: SubtitleOffIcon,
  play: PlayIcon,
  playMessage: PlayMessageIcon,
  pauseMessage: PauseMessageIcon,
  check: CheckIcon,
  lock: LockIcon,
  dictionary: DictionaryIcon,
  unfold: UnfoldIcon,
  thumbup: ThumbupIcon,
  close: CloseIcon,
  left: LeftIcon,
  profile: ProfileIcon,
  profile2: Profile2Icon,
  learning: LearningIcon,
  grammar: GrammarIcon,
  words: WordsIcon,
  send: SendIcon,
  arrowUp: ArrowUpIcon,
  arrowDown: ArrowDownIcon,
  menu: MenuIcon,
  voice: VoiceIcon,
  support: SupportIcon,
  bulb: BulbIcon,
  zoom: ZoomIcon,
  key: KeyIcon,
  trendUp: TrendUpIcon,
  asterisk: AsteriskIcon,
  checkGreen: CheckGreenIcon,
  checkGreen3: CheckGreen3Icon,
  eyeClose: EyeCloseIcon,
  eyeOpen: EyeOpenIcon,
  speaker: SpeakerIcon,
  tick: TickSvg,
  plus: PlusSvg,
  clickHand: ClickhandSvg,
  headphone: HeadphoneSvg,
  navStar: NavStarSvg,
  home: HomeSvg,
  bell: BellSvg,
  book: BookSvg,
  star: StarSvg,
  lockOpen: LockOpenSvg,
  lockClosed: LockClosedSvg,
  checkGreen2: CheckGreen2Svg,
  variableCheck: VariableCheckIcon,
  ring: RingSvg,
  google: GoogleSvg,
  apple: AppleSvg,
}

export type IconName = keyof typeof icons

interface IconProps {
  iconName: IconName
  className?: string
  onClick?: (e: React.MouseEvent) => void
  size?: keyof typeof sizes
}

const sizes = {
  xs: 12,
  little: 16,
  xsm: 18,
  sm: 20,
  small: 24,
  large: 32,
}

export const Icon = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  const { iconName, className, size, onClick, ...rest } = props
  const SvgIcon = icons[iconName]
  const finalSize = size ? sizes[size] : 24
  return (
    <SvgIcon
      ref={ref}
      width={finalSize}
      height={finalSize}
      onClick={onClick}
      className={className}
      {...rest}
    />
  )
})
Icon.displayName = 'Icon'
